import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
@Injectable({
  providedIn: 'root'
})
export class PricingService {

  constructor(private http: HttpClient,private env:EnvironmentService) {
  }

  getPricing(contract: unknown, id: string): Observable<unknown> {
    const envValue:any = this.env.getEnvironment();
    return this.http.post(envValue.baseUrl + envValue.wso2amEndPoint+ "/des" + envValue.wso2amApiVersion +"/api/v1/decisions/decisionDefinitionkey/"+ id + "/evaluate",contract )
  }
}
